import { IzzyResultFail } from '@/components/izzy/result-fail'
import { IzzySuccess } from '@/components/izzy/success'

const transcriptAnalysisFailSpeech = (
  <>
    Infelizmente não consegui ler seu histórico!
    <br />
    <br />
    <strong>Você pode adicionar manualmente as disiciplinas</strong> ou podemos
    fazer uma <strong>nova simulação com outro histórico!</strong>
  </>
)

const withoutEquivalencesSpeech = (
  <>
    Infelizmente não consegui encontrar nenhuma disciplina equivalente entre os
    currículos!
    <br />
    <br />
    Você pode adicionar manualmente as disciplinas ou podemos fazer uma nova
    simulação com outro histórico!
  </>
)

const successSpeech = (
  <>
    Pronto! Aqui estão as disciplinas que você pode aproveitar com base no seu
    histórico!
    <br />
    Se quiser, você pode também adicionar disciplinas por conta própria, se
    entender que existem mais equivalência. Mas se achar que está tudo correto é
    só enviar para nossa equipe revisar e confirmar tudo certinho.
  </>
)

export const transferIzzyVariants = {
  error: {
    izzyGif: (
      <IzzyResultFail className="absolute w-50 right-[120px] top-[-60px]">
        {transcriptAnalysisFailSpeech}
      </IzzyResultFail>
    )
  },
  withoutEquivalence: {
    izzyGif: (
      <IzzyResultFail className="absolute w-50 right-[120px] top-[-60px]">
        {withoutEquivalencesSpeech}
      </IzzyResultFail>
    )
  },
  success: {
    izzyGif: (
      <IzzySuccess className="absolute w-50 right-[120px] top-[-60px]">
        {successSpeech}
      </IzzySuccess>
    )
  }
}
